import { render } from "./LocationCard.vue?vue&type=template&id=27c0717c&scoped=true"
import script from "./LocationCard.vue?vue&type=script&lang=js"
export * from "./LocationCard.vue?vue&type=script&lang=js"

import "./LocationCard.vue?vue&type=style&index=0&id=27c0717c&lang=scss&scoped=true"

import exportComponent from "/home/forge/demo-logistic.hoornbloommasters.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c0717c"]])

export default __exports__